import { createSlice } from "@reduxjs/toolkit";

const educationalBackground = {
  university: "",
  department: "",
  graduationYear: ""
};

const initialPersonnel = {
  tcKimlikNo: "",
  name: "",
  surname: "",
  birthPlace: "",
  birthDate: "",
  homePhone: "",
  mobilePhone1: "",
  mobilePhone2: "",
  email1: "",
  email2: "",
  city: "",
  county: "",
  address: "",
  serviceYear: 0,
  workingYearInTheSchool: 0,
  yearOfSeniority: 0,
  personnelTypes: [],
  contract: {
    term: 0,
    insuranceStartDate: "",
    insuranceEndDate: "",
    contractStartDate: "",
    contractEndDate: "",
    formalContractStartDate: "",
    formalContractEndDate: "",
    salary: "",
    formalSalary: "",
    bank: "",
    accountNo: "",
    iban: ""
  },
  graduate: educationalBackground,
  postGraduate: educationalBackground,
  doctorate: educationalBackground,
  partner: {
    tcKimlikNo: "",
    name: "",
    surname: "",
    occupation: "",
    occupationCategories: []
  }
};

const initialPersonnelsState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  authorities: null,
  personnelTypes: [],
  personnel: initialPersonnel
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const personnelSlice = createSlice({
  name: "personnels",
  initialState: initialPersonnelsState,
  reducers: {
    startCall: (state, action) => {
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getPersonnels
    personnelsFetched: (state, action) => {
      const { isSuccess, type, totalCount, entities, authorities } = action.payload;
      state.listLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.entities = entities;
      state.totalCount = totalCount;
      state.authorities = authorities;
    },
    // getPersonnelTypes
    personnelTypesFetched: (state, action) => {
      const { isSuccess, type, entities } = action.payload;
      state.actionsLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.personnelTypes = entities;
    },
    //getPersonnel
    personnelFetched: (state, action) => {
      state.actionsLoading = false;
      state.isSuccess = action.payload.isSuccess;
      state.type = action.payload.type;
      state.personnel = action.payload.entity;
    },
    //completeAction
    actionCompleted: (state) => {
      state.actionsLoading = false;
    },
    //cleanPersonnelsState
    personnelsStateCleaned: (state) => {
      state.listLoading = false;
      state.actionsLoading = false;
      state.isSuccess = undefined;
      state.type = undefined;
      state.totalCount = 0;
      state.entities = undefined;
      state.personnel = initialPersonnel;
    }
  }
});